import { Box, Typography } from '@mui/material';

const AnaliticaScore = ({ score, styles, pstyles, fontSize = '16px', width = '40px', height = '20px' }) => {
    const getBackground = () => {
        if (!score) return '#ccc';
        if (score >= 8) {
            return '#1D6FB1 ';
        } else if (score >= 7) {
            return '#01aa4d';
        } else if (score >= 6) {
            return '#ed6c02';
        } else {
            return '#d32f2f';
        }
    };

    const getScore = () => {
        const numericScore = parseFloat(score); // Asegúrate de que score se trate como número
        if (!isNaN(numericScore)) {
            if (numericScore % 1 === 0) {
                // Verifica si tiene parte decimal
                return `${numericScore}.0`;
            } else {
                return numericScore.toString();
            }
        } else {
            return '-';
        }
    };

    const getColor = () => {
        if (!score) return '#000';
        return '#fff';
    };
    return (
        <Box className="fixture-score-container">
            <Box
                className="fixture-score-container__color"
                style={{
                    background: getBackground(),
                    width: width,
                    minWidth: '40px',
                    height: height,
                    fontSize: '12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '4px',
                    color: '#fff',
                    ...styles,
                }}
            >
                <Typography
                    style={{
                        margin: 0,
                        ...pstyles,
                        fontSize: fontSize,
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        overflow: 'hidden',
                        color: getColor(),
                    }}
                >
                    {getScore()}
                </Typography>
            </Box>
        </Box>
    );
};

export default AnaliticaScore;
